import React, { Component } from "react";
import Header from "../../Component/header/Header";
import Sidebar from "../../Component/sidebar/sidebar";
import Usersiconimg from "../../image/users.svg";
import Creatable from "react-select/creatable";
import Button from 'react-bootstrap/Button';


const options = [
  { value: "ROLE", label: "ROLE" },
  { value: "System Engineer", label: "System Engineer" },
  { value: "Desktop Support", label: "Desktop Support" },
  { value: "Software Engineer", label: "Software Engineer" },
  { value: "Operation Manager", label: "Operation Manager" },
  { value: "Project Manager", label: "Project Manager" },
];

class NewUsers extends Component {
  render() {
    return (
      <div className="container">
        <div className="row row-cols-2">
          {/* SIDEBAR DESIGN */}
          <div className="col-2 sidebar">
            <Sidebar />
          </div>

          {/* CONTENT DESIGN */}
          <div className="col-10 content">
            <Header title={"Create Users"} />
            {/* management section */}
            <div className="container usermain">
              <div className="row">
                <div className="col-1">
                  <div className="userlogo">
                    <img src={Usersiconimg} alt="" className="userlogoicon" />
                  </div>
                </div>

                <div className="col-11">
                  <div className="usersearchsec">
                    <span className="usertitle">Create New Users</span>
                  </div>

                  <div className="row ExeFrow">
                    <div className="col-5 searchboxExe">
                      <Creatable
                        options={options}
                        className="epmsearchoptionbox"
                        defaultValue={options[0]}
                      />
                    </div>
                    <div className="col-4 searchboxExe">
                      <input type="text" placeholder="Discription" />
                    </div>
                    <div className="col-5 searchboxExe">
                      <input type="text" placeholder="Any Query" />
                    </div>

                    <div className="col-12 Exebutton newUsersButton">
                      <Button variant="danger" size="sm">
                        Clear
                      </Button>{" "}
                      &nbsp; &nbsp; &nbsp;
                      <Button variant="success" size="sm">
                        Save
                      </Button>
                      &nbsp; &nbsp; &nbsp;
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default NewUsers;
